module.exports = __webpack_public_path__ + "img/menu-icon.837ae592.svg";